import React, { PropsWithChildren, useEffect, useState } from "react";
import { Avatar, Layout, Popover, theme } from "antd";
import { Drawer } from "antd";
import { format } from "date-fns";
import styles from "./main.module.css";
import SideBar from "./sidebar";
import HeaderCard from "./headerCard/headerCard";
import { ReactComponent as ArrowDown } from "../../assets/svgs/angle-down.svg";
import { ReactComponent as NotiBell } from "../../assets/svgs/bell.svg";
import { ReactComponent as Harmbugger } from "../../assets/svgs/hambugger.svg";
import NotificationCard from "./notificationCard/notificationCard";
import { useAtomValue } from "jotai";
import { profileDetails, userAtom } from "../../utils/store";
import { handleLogOut, logoutIfTokenExpired } from "../helpers";

interface ComponentProp extends PropsWithChildren {
  title?: React.ReactNode;
  pageHeading?: string;
}

const { Content } = Layout;

const CLayout: React.FC<ComponentProp> = ({ children, title, pageHeading }) => {
  const [open, setOpen] = useState([false, false]);
  const userDetails = useAtomValue(profileDetails);
  const user = useAtomValue(userAtom);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const toggleDrawer = (idx: number, target: boolean) => {
    setOpen((p) => {
      p[idx] = target;
      return [...p];
    });
  };

  const currentDate = new Date();
  const formattedDate = format(currentDate, "do MMMM, yyyy");

 useEffect(()=> {
  if(logoutIfTokenExpired(user?.Expiration)){
    handleLogOut();
  }
 }, [user?.Expiration]) 


  return (
    <main className={styles.main}>
      <Drawer
        placement="left"
        onClose={() => toggleDrawer(0, false)}
        open={open[0]}
        className={styles.drawer}
        width={"300px"}
        styles={{ body: { padding: "0px" } }}
      >
        <SideBar className={styles.drawSideBar} />
      </Drawer>

      <SideBar className={styles.sideBar} />

      <div className={styles.superHeader}>
        <div className={styles.header}>
          <div>
            <Harmbugger
              onClick={() => toggleDrawer(0, true)}
              className={styles.harmbugger}
            />

            <p className={styles.pageHeading}>{pageHeading}</p>
          </div>

          <div>
            <span>{formattedDate}</span>

            {/* <div className={styles.wrapper}>
              <NotiBell />
              <div className={styles.hoveringCircle}>9+</div>

              <div className={styles.popover}>
                <NotificationCard />
              </div>
            </div> */}

            <div className={styles.pill}>
              <Avatar src={userDetails?.UploadPictureUrl} size={29} />

              <Popover
                placement="bottomRight"
                content={
                  <HeaderCard
                    profilePicture={userDetails?.UploadPictureUrl ?? ''}
                    firstName={userDetails?.Name ?? ''}
                  />
                }
              >
                <ArrowDown />
              </Popover>
            </div>
          </div>
        </div>

        <Content
          className={styles.content}
          style={{
            paddingBlock: 24,
            margin: 0,
            minHeight: 280,
            overflowX: "hidden",
            overflowY: "auto",
            backgroundColor: "#F3F3F3",
          }}
        >
          {pageHeading && (
            <div>
              <p className={styles.title}>{title}</p>
            </div>
          )}

          {children}
        </Content>
      </div>
    </main>
  );
};

export default CLayout;
